module.exports = __webpack_public_path__ + "static/media/class_small_mage.9b3b210e.png";